module.exports = __webpack_public_path__ + "img/login.9cb291c4.jpg";